const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolveImg = (u) => {
  if (!u) return u;
  return u.startsWith("/api/") ? `${BACKEND}${u}` : u;
};
